import { handleActions } from "redux-actions";
import {
  PROFITBILITY_REQUEST,
  PROFITBILITY_SUCCESS,
  TENANTS_LIST_REQUEST,
  TENANTS_LIST_SUCCESS,
  UNITS_LIST_REQUEST,
  UNITS_LIST_SUCCESS,
} from "./types";

const initState = {
  tenantsListData: null,
  unitsListData: null,
  profitbilityData: null,
  tenantsTermsData: null,
};

export default handleActions(
  {
    [TENANTS_LIST_REQUEST]: (state) => ({
      ...state,
    }),
    [TENANTS_LIST_SUCCESS]: (state, { payload }) => {
      return { ...state, tenantsListData: payload };
    },

    [UNITS_LIST_REQUEST]: (state) => ({
      ...state,
    }),
    [UNITS_LIST_SUCCESS]: (state, { payload }) => {
      return { ...state, unitsListData: payload };
    },

    [PROFITBILITY_REQUEST]: (state) => ({
      ...state,
    }),
    [PROFITBILITY_SUCCESS]: (state, { payload }) => {
      return { ...state, profitbilityData: payload };
    },
  },
  initState
);
